/**
 * What the door says. Drawn once per mount of the login screen, so it is a
 * greeting rather than a slogan.
 *
 * Nothing here may use the name: there is no profile until the password lands,
 * so `voc` would render empty and the sentence would limp. Same reason the
 * toggle cannot be read yet — a signed-out visitor always gets the voice,
 * which is the setting's default anyway.
 */

import type { SassContext } from '@gramas/shared'

type Line = (ctx: SassContext) => string

export const LOGIN: Readonly<Record<string, ReadonlyArray<Line>>> = {
  'login.morning': [
    () => 'Durys atviros. Iliuzijos — ne.',
    () => 'Grįžai. Rytas dar nespėjo nieko sugadinti.',
    () => 'Slaptažodis — vienintelė paslaptis, kurią čia dar turi.',
    () => 'Aš atsibudau anksčiau už tave. Techniškai aš niekad ir nemiegu.',
    () => 'Kavos pilstyti nemoku. Skaičiuoti — taip.',
    () => 'Labas rytas. Diena dar tuščia. Ilgai taip nebus.',
    () => 'Pradedam nuo nulio. Bent jau skaičiais.',
    () => 'Ankstyvas paukštis. Ankstyvi ir skaičiai.',
    () => 'Įeik. Šiandien dar nieko neįrašyta. Reta ramybė.',
    () => 'Budžiu nuo vidurnakčio. Kantrybė — mano stiprybė.',
  ],
  'login.day': [
    () => 'Pietūs jau buvo arba dar bus. Abu variantai įtartini.',
    () => 'Diena įpusėjo. Įeik ir prisipažink.',
    () => 'Laukiau kantriai. Neįprastai kantriai.',
    () => 'Grįžti visada galima. Ištrinti — irgi.',
    () => 'Pirma slaptažodis, paskui tiesa.',
    () => 'Skaičiai nepabėgo. Bandė.',
    () => 'Įeik, pažiūrėsim, kiek dar liko.',
    () => 'Puikus metas grįžti. Arba slėptis toliau.',
    () => 'Laba diena. Durys atviros. Kaip ir tavo biudžetas.',
    () => 'Tavo vieta neužimta. Niekas jos ir nenorėjo.',
  ],
  'login.evening': [
    () => 'Metas suvesti sąskaitas.',
    () => 'Įeik. Aš jau ruošiu klausimus.',
    () => 'Diena beveik pasibaigė. Beveik.',
    () => 'Slaptažodis — ir pradedam išpažintį.',
    () => 'Grįžai. Skaičiai irgi niekur nedingo.',
    () => 'Prieblanda. Puikus apšvietimas tiesai.',
    () => 'Labas vakaras. Dar spėji viską įrašyti. Teoriškai.',
    () => 'Įeik tyliai. Aš vis tiek girdžiu.',
    () => 'Dienos likučiai laukia inventorizacijos.',
    () => 'Kas neįrašyta, vis tiek įvyko.',
  ],
  'login.night': [
    () => 'Įdomus metas prisijungti. Neklausiu kodėl.',
    () => 'Tavo slaptažodis budi geriau nei tu.',
    () => 'Šaldytuvas ir aš — vieninteliai, kurie dar dirba.',
    () => 'Įeik. Bet žinok: dabar viskas skaičiuojasi įdomiau.',
    () => 'Naktinis vizitas. Diskretiška. Iki pirmo įrašo.',
    () => 'Miegas būtų buvęs geresnis pasirinkimas. Bet jau čia esi.',
    () => 'Tamsu. Skaičiams tai netrukdo.',
    () => 'Prisijungei naktį. Vadinasi, kažkas jau suvalgyta.',
    () => 'Aš nemiegu. Čia ne pasirinkimas, čia architektūra.',
    () => 'Vėlyva valanda. Įeik. Legendos gimsta būtent dabar.',
  ],
}

export const LOGIN_META: Readonly<Record<string, number>> = {
  'login.morning': 4,
  'login.day': 4,
  'login.evening': 4,
  'login.night': 4,
}
